import React from "react";

function CCTVLegislation() {
    return (
        <div>
            <h2>CCTV Codes of Practice, Operational Procedures & Legislation</h2>
            <p>
                CCTV operators must understand and follow the legal and procedural framework that governs surveillance. This module outlines key legislation, ethical standards, and operational protocols to ensure lawful and responsible use of CCTV.
            </p>

            <h3>Key Legislation</h3>
            <ul>
                <li><strong>Data Protection Act 2018</strong> – Regulates the collection, storage, and use of personal data</li>
                <li><strong>Human Rights Act 1998</strong> – Ensures surveillance respects privacy and dignity</li>
                <li><strong>Freedom of Information Act 2000</strong> – Allows individuals to request access to recorded data</li>
                <li><strong>Protection of Freedoms Act 2012</strong> – Introduced the Surveillance Camera Code of Practice</li>
                <li><strong>Regulation of Investigatory Powers Act 2000 (RIPA)</strong> – Governs covert surveillance</li>
            </ul>

            <h3>Surveillance Camera Code of Practice</h3>
            <ul>
                <li>Issued by the Home Office under the Protection of Freedoms Act</li>
                <li>Promotes transparency, accountability, and proportionality</li>
                <li>Applies to public space surveillance systems</li>
                <li>Encourages regular reviews of system effectiveness and necessity</li>
            </ul>

            <h3>Operational Procedures</h3>
            <ul>
                <li>Follow site-specific Standard Operating Procedures (SOPs)</li>
                <li>Log all incidents, footage reviews, and system checks</li>
                <li>Restrict access to authorized personnel only</li>
                <li>Ensure footage is stored securely and retained only as long as necessary</li>
                <li>Label and preserve evidence correctly for investigations</li>
            </ul>

            <h3>Data Protection Principles</h3>
            <ul>
                <li>Use data fairly, lawfully, and transparently</li>
                <li>Collect only what is necessary for a specific purpose</li>
                <li>Keep data accurate and up to date</li>
                <li>Store data securely and limit access</li>
                <li>Allow individuals to access their personal data upon request</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
                <li><a href="https://ico.org.uk/for-organisations/guide-to-data-protection/" target="_blank" rel="noreferrer">ICO – Guide to Data Protection</a></li>
                <li><a href="https://www.legislation.gov.uk/" target="_blank" rel="noreferrer">UK Legislation – Official Site</a></li>
            </ul>
        </div>
    );
}

export default CCTVLegislation;
